module.exports = __webpack_public_path__ + "static/jci-foundation-logo-0f58cd913be2e6045d1feb183691ddbe.png";